import React , { useEffect , useState} from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import Layout from './Boutique/components/Layout'; // Assurez-vous de corriger le chemin
import Accueil from './Boutique/components/pages/Accueil';
import Tickets from './Boutique/components/pages/Tickets';
import Produits from './Boutique/components/pages/Produits';
import Tentes from './Boutique/components/pages/Tentes';
import Contacts from './Boutique/components/pages/Contacts';
import CartPage from './Boutique/components/pages/Cart';
import BuyPage from './Boutique/components/pages/Achat';
import Recap from './Boutique/components/pages/Recap';
import Faq from './Boutique/components/pages/Faq';
import { SelectedPointProvider } from './Boutique/components/pages/SelectedPointContext'; 
import { I18nextProvider } from 'react-i18next';  // Importer le provider
import i18n from './i18n';  // Importer la configuration i18next
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ScrollToTop from "./Boutique/components/ScrollToTop"; 
import CookiesPage from './Boutique/components/CookiesPage';
import GoogleAnalyticsTracker from './analytics'; 
import ErrorPage500 from "./Boutique/components/pages/ErrorPage500";
import Error500 from "./Boutique/components/pages/Error500";
import Navbar from "./Boutique/components/Navbar";
import { CartProvider } from "../src/Boutique/components/CartContext";
const App = () => {


  return (
    <I18nextProvider i18n={i18n}>
      <GoogleAnalyticsTracker />
      <SelectedPointProvider>
      <CartProvider>
      <Router>
      <ScrollToTop />
      <ToastContainer position="top-right" autoClose={800} limit={3}/>
        <Routes>
          <Route path="/" element={<Layout />}>
            {/* Route par défaut pour rediriger vers Accueil */}
            <Route index element={<Accueil />} />
            <Route path="tickets" element={<Tickets />} />
            <Route path="produits" element={<Produits />} />
            <Route path="tentes" element={<Tentes />} />
            <Route path="contacts" element={<Contacts />} />
            <Route path="panier" element={<CartPage />} />
            <Route path="recap" element={<Recap />} />
            <Route path="achat" element={<BuyPage />} />
            <Route path="FAQ" element={<Faq />} />
            <Route path="cookies-policy" element={<CookiesPage />} />
            <Route path="*" element={<ErrorPage500 />} />
            <Route path="500" element={<Error500 />} />
          </Route>
          <Route path="/" element={<Navigate to="/" replace />} />
        </Routes>
      </Router>
      </CartProvider>
      </SelectedPointProvider>

    </I18nextProvider>
  );
};

export default App;
